import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Typography, Modal, Carousel, message, notification, Button, Spin } from 'antd';
import { useHistory } from 'react-router-dom';
import 'react-simple-keyboard/build/css/index.css';
import htmlToDraft from 'html-to-draftjs';
import _ from 'lodash';
import { EditorState, ContentState } from 'draft-js';
import RecordRTC, { StereoAudioRecorder } from 'recordrtc';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Editor } from 'react-draft-wysiwyg';
import ReactPlayer from 'react-player';
import styled from 'styled-components';
import * as diff_match_patch from 'diff-match-patch';
import { LoadingOutlined, CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { captureUserMedia } from 'src/utils';
import { CREATE_EXTERNAL_USER_STUDY } from 'src/operations/mutations/externalUserStudy';
import { CREATE_SIGNED_S3_UPLOAD } from 'src/operations/mutations/uploadFileS3';
import { useMutation } from '@apollo/client';
import moment from 'moment';
import { createRecordingObjectUrl, processKaldiSttWithRetry, uploadRecordingWithRetry } from 'src/utils/recordingNetwork';
const dmp = new diff_match_patch();

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffda00;
`;

const { Title } = Typography;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const useCheckScreen = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const handleWindowSizeChange = () => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return [width > 1600 ? 1 : width / 1600, height > 900 ? 1 : height / 900];
};

const imgState = ['/images/icon_rec.png', '/images/bluestop.png', '/images/icon_speak.png'];
const WPM_GOAL = {
  1: 150,
  2: 150,
  3: 150,
  4: 150,
  5: 150,
  6: 150,
  7: 160,
  8: 160,
};

const LevelupRecording = ({ dataNew, articleData, articleId, assignedIdx, userData, code, idx }) => {
  let width = useCheckScreen()[0];
  let height = useCheckScreen()[1];
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [text, setText] = useState(EditorState.createEmpty());
  const [textRest, setTextResp] = useState(EditorState.createEmpty());
  const [currentLessonText, setCurrentLessonText] = useState([]);
  const [firstPageNo, setFirstPageNo] = useState(0);
  // const [isMobile, setIsMobile] = useState(useCheckMobileScreen());
  const [doneLessonText, setDoneLessonText] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [currentText, setCurrentText] = useState([]);
  const [lastText, setLastText] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [lastPage, setLastPage] = useState([]);
  const [startPageIndx, setStartPageIndx] = useState(-1);
  const [isLoading, setIsLoading] = useState(false);
  const [imageSize, setImageSize] = useState('100%');
  const [currentRecLength, setCurrentRecLenght] = useState(0);
  const [isRecording, setIsRecording] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [recordingData, setRecordignData] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [playing, setPlaying] = useState(false);
  const [lastBlob, setLastBlob] = useState(null);
  const recordAudio = useRef(null);
  const recordingRequestId = useRef(0);
  const recordingRequested = useRef(false);
  const [blobChunks, setBlobChunks] = useState([]);
  const currentSttRequest = useRef([]);
  const currentSttText = useRef([]);
  const [currentProgressSlider, setCurrentProgressSlider] = useState(0);
  const [currentDoneValue, setCurrentDoneValue] = useState(null);
  const [processCallbackLoading, setProcessCallbackLoading] = useState([]);
  const currentTextValue = currentText.map((e) => e.text).join('\n');
  const [apiSuccess, setApiSuccess] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const carouselRef = useRef(null);
  const recorderStreams = useRef(null);

  // message.config({
  //   top: "45%",
  //   duration: 1,
  //   getContainer: () => mainBlockRef.current,
  // });
  const [createExternalUserStudy, { loading: loadingSave }] = useMutation(CREATE_EXTERNAL_USER_STUDY, {
    onCompleted: () => {
      //저장까지 해야 완료
    },
    onError(error) {
      alert('error');
      console.log('error', error);
    },
  });

  const [uploadFileS3] = useMutation(CREATE_SIGNED_S3_UPLOAD);

  const handleGuideCloseClick = () => {
    window.localStorage.setItem('LEVELUP_RECORDING_GUIDE_DONT_SHOW_TODAY', moment().format('YYYY-MM-DD'));
    setShowPopup(false);
  };

  useEffect(() => {
    let todayDae = moment().format('YYYY-MM-DD');
    let dontShowToday = window.localStorage.getItem('LEVELUP_RECORDING_GUIDE_DONT_SHOW_TODAY');

    if (dontShowToday !== todayDae) {
      setShowPopup(true);
    }
  }, []);

  useEffect(() => {
    if (dataNew.length > 0 && !apiSuccess) {
      setApiSuccess(true);
      let recData = dataNew.map((item, indx) => ({ ...item, page_no: indx, page: indx }));
      const recIndx = recData.reduce(function (acc, d, i) {
        acc.push(i);
        return acc;
      }, []);
      if (recIndx[recIndx.length - 1] === recData.length) {
        recData = recData.slice(recIndx[0]);
      } else {
        recData = recData.slice(recIndx[0], recIndx[recIndx.length - 1] + 1);
      }
      setTotalPage(recData.length);
      setFirstPageNo(recData[0]['page']);
      let donePages = window.localStorage.getItem(`PASSAGE_${code}_${userData.idx}`);
      donePages = donePages ? JSON.parse(donePages) : [];
      let startPageIndx = recData[0]['page'];
      let soneKeys = Object.keys(donePages);

      if (soneKeys.length) {
        startPageIndx = parseInt(soneKeys.pop());
        let tempData = [];
        donePages.forEach((e, i) => {
          if (e) tempData[i] = e;
        });
        currentSttText.current = tempData;
        message.info(` ${startPageIndx + 1} 페이지까지 학습 기록이 있습니다. 다음 페이지부터 이어서 학습하세요. `);
      }

      setStartPageIndx(startPageIndx);
      setRecordignData(recData);

      //   // if(![0,1].includes(data?.getRecordingStudyData[0]["page_no"])) message.info(`Goto page ${data?.getRecordingStudyData[0]["page_no"]}`);
    }
  }, [dataNew]);

  const [imageState, setImageState] = useState(0);

  useEffect(() => {
    if (recordingData.length) {
      // let phraseList = recordingData.filter((e) => parseInt(e.recording));
      let phraseList = recordingData.map((e) => e.text);
      setCurrentLessonText(phraseList);
    }
  }, [recordingData, processCallbackLoading]);

  useEffect(() => {
    let donePages = window.localStorage.getItem(`PASSAGE_${code}_${userData.idx}`);
    donePages = donePages ? JSON.parse(donePages) : [];

    setCurrentDoneValue(donePages[currentPage]);
  }, [currentPage, processCallbackLoading]);

  const sleep = (m) => new Promise((r) => setTimeout(r, m));

  useEffect(() => {
    recordingRequested.current = isRecording;
    const requestId = ++recordingRequestId.current;

    if (isRecording) {
      setCurrentRecLenght(0);
      startRecord(currentPage, requestId);
    } else {
      if (recordAudio.current && recordAudio.current[currentPage]) {
        stopRecording(currentPage);
      } else {
        stopRecording(lastPage);
      }
    }
  }, [isRecording]);

  useEffect(
    () => () => {
      recordingRequested.current = false;
      recordingRequestId.current += 1;
      recorderStreams.current?.getTracks?.().forEach((track) => track.stop());
      recorderStreams.current = null;
    },
    [],
  );

  useEffect(() => {
    setIsRecording(false);
    if (apiSuccess) {
      setLastText(currentText);
      let phraseList = recordingData.filter((e) => currentPage == e.page);
      if (phraseList.length) {
        // let recordginPage = phraseList.filter((e) => parseInt(e.recording));
        setCurrentText(phraseList);
      } else if (gotoNext && Object.values(currentSttText.current).length > 0 && recordingData.length) {
        const fitlerrec = recordingData.filter((p) => p.text);
        const allReqDone = Object.values(currentSttRequest.current).filter((p) => !p);
        if (!allReqDone.length) {
          let soneKeys = Object.keys(currentSttText.current).map((p) => parseInt(p));
          let filNotDone = fitlerrec.filter((r) => !soneKeys.includes(r.page_no));
          if (filNotDone.length) {
            Modal.destroyAll();
            // Modal.error({
            //   icon: null,
            //   title: 'Not Complete',
            //   content: (
            //     <Title level={4}>
            //       {`  학습이 완료되지 않았습니다.`}
            //       <br />
            //       {`${filNotDone.map((p) => p.page_no).join(',')} 페이지를 확인하세요.`}
            //     </Title>
            //   ),
            // });
          } else {
            window.localStorage.removeItem(`PASSAGE_${code}_${userData.idx}`);
            const cSttText = Object.values(currentSttText.current);
            const accuracy = parseInt(cSttText.reduce((p, t) => p + t.accuracy, 0) / cSttText.length);
            const wpm = parseInt(cSttText.reduce((p, t) => p + t.wpm, 0) / cSttText.length);
            Modal.destroyAll();
            Modal.info({
              icon: null,
              title: 'Done',
              content: <Title level={4}>{`  당신의 점수는 ${accuracy} 점 입니다. 학습을 종료합니다.`}</Title>,
              onOk: () => {
                gotoNext(
                  {
                    exam_total: 100,
                    exam_correct: accuracy,
                    message: `당신의 점수는 ${accuracy} 점 입니다. 학습을 종료합니다.`,
                    exitMessage: `학습을 종료하시겠습니까?`,
                    recording_data: cSttText.map((e) => `<p>${e.text}</p>`).join(''),
                    wpm,
                  },
                  true,
                );
              },
            });
          }
        } else if (!showLoading) {
          setShowLoading(true);
        }
      } else {
        setCurrentText([]);
      }
    }
  }, [currentPage, startPageIndx, showLoading, apiSuccess]);

  const openModel = () => {
    let filteredTexts = [currentTextValue].filter((f) => f !== '' && f);
    const { contentBlocks, entityMap } = htmlToDraft(filteredTexts.map((e) => `<p>${e}</p>`).join());
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    setText(EditorState.createWithContent(contentState));

    const cb2 = htmlToDraft(
      Object.values(currentDoneValue ? [currentDoneValue] : [])
        .map((e) => `<p>${e.text}</p>`)
        .join(),
    );
    const contentState2 = ContentState.createFromBlockArray(cb2.contentBlocks, cb2.entityMap);
    setTextResp(EditorState.createWithContent(contentState2));

    setShowModal(true);
  };

  const processRecordCallback = useCallback(
    async (blob, textA, currentRecLength, s3UrlOrPromise, page) => {
      let fd = new FormData();
      let text = textA.map((p) => p);
      text.push('[unk]');
      fd.append('audio', blob);
      fd.append('sample_rate', 16000);
      currentSttRequest.current[page] = false;

      let sanitizePhraseList = text.map((e) =>
        e
          .replace(/\n/g, ' ')
          .replace(/[\u2010-\u2015\u2212]/g, ' ')
          .replace(/[.,?!’“”]/gi, '')
          .toLowerCase(),
      );

      fd.append('phrase_list', JSON.stringify(sanitizePhraseList));
      sanitizePhraseList = sanitizePhraseList.map((e) => e.replace(/[0-9]{1,}/gi, '').replace(/\s{2,}/gi, ' '));
      let phList = sanitizePhraseList.reduce((p, n) => p.concat(n.split(' ')), []).filter((p) => p !== '' && p !== '[unk]');
      const s3UrlPromise = Promise.resolve(s3UrlOrPromise);

      if (phList.length === 0) {
        await s3UrlPromise;
        return;
      }

      processCallbackLoading[page] = true;
      setProcessCallbackLoading(JSON.parse(JSON.stringify(processCallbackLoading)));

      const sttPromise = processKaldiSttWithRetry(fd);
      const [resData, resolvedS3Url] = await Promise.all([sttPromise, s3UrlPromise]);
      processCallbackLoading[page] = false;
      setProcessCallbackLoading(JSON.parse(JSON.stringify(processCallbackLoading)));

      let prev = currentSttText.current;

      let dataSplit = resData.text.split(' ');
      resData.text = resData.text.replace('[unk]', '');

      // const filteredArray = phList.filter(value => dataSplit.includes(value));
      dmp.Diff_Timeout = 5;
      dmp.Diff_EditCost = 5;
      resData['accuracy'] = 0;
      resData['duration'] = currentRecLength;
      resData['wpm'] = currentRecLength > 0 ? (dataSplit.length / (currentRecLength / 1000)) * 60 : 0;
      const d = dmp.diff_main(
        textA
          .map((e) =>
            e
              .replace(/[\u2010-\u2015\u2212]/g, ' ')
              .replace(/[.,?!’“”]/gi, '')
              .replace(',', ' ')
              .toLowerCase(),
          )
          .reduce((p, n) => p + n, ''),
        resData.text,
      );
      dmp.diff_cleanupSemantic(d);
      let htmltext = [];
      d.forEach((element, i) => {
        if (element[0] === 0) {
          const filteredArrayl = element[1].split(' ').filter((value) => phList.includes(value));
          resData['accuracy'] += filteredArrayl.length;
          htmltext.push(`<span style="color:black;">${element[1]}</span>`);
        } else if (element[0] === -1) {
          let filterData = element[1].replace(/[0-9]{1,}/gi, '').replace(/\s{2,}/gi, ' ');
          let filteredArrayl = filterData.split(' ').filter((value) => phList.includes(value));
          if (filteredArrayl.length > 0) {
            resData['accuracy'] = resData['accuracy'] ? resData['accuracy'] - filteredArrayl.length / 6 : 0;
          }
          htmltext.push(`<span style="color:brown; text-decoration:line-through;">${element[1]}</span>`);
        } else if (element[0] === 1) {
          htmltext.push(`<span style="color:darkblue;">${element[1]}</span>`);
        }
      });
      let tempAccuracy = phList.length > 0 ? resData['accuracy'] / (phList.length / 100) : 0;
      tempAccuracy = tempAccuracy > 100 ? 100 : tempAccuracy;
      resData['accuracy'] = tempAccuracy > 0 ? Math.floor(tempAccuracy) : 0;
      resData.text =
        htmltext.join('') + '<sup><a style="margin-left:5px;" href="' + resolvedS3Url + '" target="_blank"> Audio' + (page + 1) + '</a></sup>';
      prev[page] = resData;
      resData['words'] = phList.length;

      currentSttRequest.current[page] = true;
      window.localStorage.setItem(`PASSAGE_${code}_${userData.idx}`, JSON.stringify(prev));
      setCurrentDoneValue(resData);
      setShowLoading(false);

      currentSttText.current = prev;
      notification.success({ message: '저장되었습니다.', placement: 'topRight' });
    },
    [currentSttRequest],
  );

  const stopRecording = (page) => {
    setImageState(0);
    if (recordAudio.current != null && recordAudio.current[page]) {
      // message.info('Recording Stopped');
      recordAudio.current[page].stopRecording(async () => {
        setIsLoading(true);
        setDoneLessonText((prev) => {
          let temp = prev.concat(currentLessonText);
          return temp;
        });
        const recordedBlob = recordAudio.current[page].getBlob();
        const uploadPromise = uploadRecordingWithRetry(
          async ({ name, contentType, replace }) => {
            const res = await uploadFileS3({
              variables: { name, contentType, replace },
            });
            return res?.data?.createSignedS3Upload;
          },
          {
            name: `LEVELUP-RECORDING-${userData.idx}-${articleId}-${page + 1}.wav`,
            blob: recordedBlob,
          },
        );

        const recorder = recordAudio.current[page];
        void processRecordCallback(
          recordedBlob,
          currentText.map((e) => e.text),
          currentRecLength,
          uploadPromise,
          page,
        )
          .catch((error) => {
            currentSttRequest.current[page] = false;
            processCallbackLoading[page] = false;
            setProcessCallbackLoading(JSON.parse(JSON.stringify(processCallbackLoading)));
            setShowLoading(false);
            console.error('Recording processing failed', error);
            message.error('Recording processing failed. Please check your network and try again.');
          })
          .then(() => setIsLoading(false));
        const previewUrl = createRecordingObjectUrl(recordedBlob);
        if (previewUrl) setLastBlob(previewUrl);
        recorder.destroy();
        recordAudio.current[page] = null;
        if (recorderStreams.current) {
          recorderStreams.current.getTracks().forEach((track) => track.stop());
          recorderStreams.current = null;
        }
      });
    }
  };

  const pauseRecording = async (page) => {
    if (recordAudio.current && recordAudio.current[page]) {
      if (recordAudio.current[page].state === 'recording') {
        setImageState(2);
        recordAudio.current[page].pauseRecording();
        try {
          let lastBlob = new Blob(recordAudio.current[page].buffer);
          setLastBlob(URL.createObjectURL(lastBlob));
        } catch (e) {
          console.log(e);
        }
      } else {
        setImageState(1);
        recordAudio.current[page].resumeRecording();
        setPlaying(false);
      }
    }
  };

  const onDataAvailableCallback = useCallback(async (blob) => {
    setImageSize(100 - Math.floor(Math.random() * 10 + 1) + '%');

    setCurrentRecLenght((prev) => prev + 100);
    blob = await new Response(blob).arrayBuffer();

    setBlobChunks((prev) => {
      prev.push(blob);
      return prev;
    });
  }, []);

  const startRecord = (page, requestId) => {
    if (!isActive) return;
    captureUserMedia({ audio: { echoCancellation: true } }, async (stream) => {
      if (!recordingRequested.current || recordingRequestId.current !== requestId) {
        stream.getTracks().forEach((track) => track.stop());
        return;
      }

      if (!recordAudio.current) recordAudio.current = [];
      recorderStreams.current = stream;
      recordAudio.current[page] = RecordRTC(stream, {
        type: 'audio',
        mimeType: 'audio/wav',
        sampleRate: 48000,
        desiredSampRate: 16000,

        recorderType: StereoAudioRecorder,
        numberOfAudioChannels: 1,

        //1)
        // get intervals based blobs
        // value in milliseconds
        // as you might not want to make detect calls every seconds
        timeSlice: 100,

        // 2)
        // as soon as the stream is available
        ondataavailable: onDataAvailableCallback,
      });
      setBlobChunks([]);
      setLastBlob(null);
      recordAudio.current[page].startRecording();

      await sleep(500);
      if (
        !recordingRequested.current ||
        recordingRequestId.current !== requestId ||
        !recordAudio.current?.[page]
      ) {
        return;
      }
      message.info('Recording Started');
      setImageState(1);
    }, () => {
      if (recordingRequestId.current !== requestId) return;
      recordingRequested.current = false;
      recordingRequestId.current += 1;
      setIsRecording(false);
    });
  };

  const pageMove = (page) => {
    setCurrentPage(page);
  };

  const handleCloseClick = () => {
    Modal.confirm({
      icon: null,
      title: 'Exit',
      content: (
        <Title level={4} style={{ textAlign: 'center', lineHeight: 2 }}>
          학습이 완료되지 않았습니다. 재접속시 기존 학습 이후부터 진행됩니다. 학습을 종료하시겠습니까?
        </Title>
      ),
      onOk: () => history.push('/'),
    });
  };
  const gotoNext = async (data) => {
    const external_user_study_input = {
      user_idx: !_.isNil(userData.idx) ? parseInt(userData.idx) : 0,
      external_study_idx: parseInt(articleId),
      // assigned_idx: parseInt(assignedIdx),
      type: 'levelup',
      // lesson_code: lessonCode,
      // stage_no: parseInt(stageNumber),
      article_data: articleData,
      recording_data: data.recording_data,
      wpm: data.wpm,
      exam_total: data.exam_total,
      exam_correct: data.exam_correct,
    };

    if (assignedIdx) {
      external_user_study_input['assigned_idx'] = parseInt(assignedIdx);
    }

    if (idx) {
      external_user_study_input['idx'] = parseInt(idx);
    }

    await createExternalUserStudy({
      variables: { external_user_study_input },
    });

    history.goBack();
  };

  const handleUploadClick = () => {
    const fitlerrec = recordingData.filter((p) => p.text);
    const allReqDone = Object.values(currentSttRequest.current).filter((p) => !p);
    if (!allReqDone.length) {
      let soneKeys = Object.keys(currentSttText.current).map((p) => parseInt(p));
      let filNotDone = fitlerrec.filter((r) => !soneKeys.includes(r.page_no));
      if (filNotDone.length) {
        Modal.destroyAll();
        // Modal.error({
        //   icon: null,
        //   title: 'Not Complete',
        //   content: (
        //     <Title level={4}>
        //       {`  학습이 완료되지 않았습니다.`}
        //       <br />
        //       {`${filNotDone.map((p) => p.page_no + 1).join(',')} 페이지를 확인하세요.`}
        //     </Title>
        //   ),
        // });
      } else {
        window.localStorage.removeItem(`PASSAGE_${code}_${userData.idx}`);
        const cSttText = Object.values(currentSttText.current);
        let correctWords = cSttText.reduce((p, t) => p + (t.accuracy / 100) * t.words, 0);
        let totalWords = cSttText.reduce((p, t) => p + t.words, 0);
        let accuracy = parseInt((correctWords / totalWords) * 100);
        const wpm = parseInt(cSttText.reduce((p, t) => p + t.wpm, 0) / cSttText.length);
        Modal.destroyAll();
        Modal.info({
          icon: null,
          title: 'Done',
          content: <Title level={4}>{`  당신의 점수는 ${accuracy} 점 입니다. 학습을 종료합니다.`}</Title>,
          onOk: () => {
            gotoNext(
              {
                exam_total: 100,
                exam_correct: accuracy,
                message: `당신의 점수는 ${accuracy} 점 입니다. 학습을 종료합니다.`,
                exitMessage: `학습을 종료하시겠습니까?`,
                recording_data: cSttText.map((e) => `<p>${e.text}</p>`).join(''),
                wpm,
              },
              true,
            );
            setProcessCallbackLoading([]);
            currentSttText.current = [];
          },
        });
      }
    }
  };

  const totalWpm = Object.values(currentDoneValue ? [currentDoneValue] : []).length
    ? parseInt(
        Object.values(currentDoneValue ? [currentDoneValue] : []).reduce((p, t) => p + t.wpm, 0) /
          Object.values(currentDoneValue ? [currentDoneValue] : []).length,
      )
    : 0;

  const totalAccuracy = currentDoneValue ? parseInt(currentDoneValue.accuracy) : 0;

  const totalLessonText = Object.values(currentDoneValue ? [currentDoneValue] : [])
    .map((e) => `<p>${e.text}</p>`)
    .join();

  const word_count = dataNew.length > 0 ? dataNew[currentPage]['text'].split(' ').length : 0;

  if (dataNew.length == 0) {
    return '';
  }
  return (
    <>
      <Wrapper className="mainExternal-dashboard-con">
        <Modal
          title={'Match recording'}
          visible={showModal}
          width="100%"
          bodyStyle={{ height: 'calc(100vh - 200px)', overflowY: 'auto', padding: 10 }}
          style={{ top: 20, height: '80%' }}
          closable={true}
          footer={
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Title level={4} style={{ color: 'darkblue', marginTop: '10px', marginLeft: '20px' }}>
                  Extra Text
                </Title>
                <Title level={4} style={{ color: 'brown', marginTop: '10px', marginLeft: '20px' }}>
                  Missed Text
                </Title>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                <Button type="primary" key="back" style={{ margin: 10 }} onClick={() => setShowModal(false)}>
                  Done
                </Button>
                <Title level={3} style={{ margin: 10 }}>
                  WPM: {totalWpm}
                </Title>
                <Title level={3} style={{ margin: 10 }}>
                  Accuracy: {totalAccuracy}%
                </Title>
              </div>
            </div>
          }
          onCancel={() => setShowModal(false)}
        >
          <div style={{ display: 'flex', height: '100%', fontWeight: 600, color: '#383838' }}>
            <div style={{ flex: 1, background: 'beige', marginRight: 10 }}>
              <Title level={3} style={{ textAlign: 'center' }}>
                Content
              </Title>
              <Editor
                editorState={text}
                editorStyle={{
                  width: '100%',
                  height: 'calc(100% - 20px)',
                  backgroundColor: 'beige',
                  padding: 10,
                  fontSize: '18px',
                }}
                toolbarClassName="hide-print"
                wrapperClassName="essay-wrapper"
                editorClassName="essay-editor"
                readOnly={true}
                toolbarHidden
              />
            </div>
            <div style={{ flex: 1, backgroundColor: '#93babb', fontWeight: 600, color: '#383838' }}>
              <Title level={3} style={{ textAlign: 'center' }}>
                Your Response
              </Title>
              <Editor
                editorState={textRest}
                rootStyle={{ backgroundColor: '#93babb' }}
                editorStyle={{
                  width: '100%',
                  height: 'calc(100% - 20px)',
                  backgroundColor: '#93babb',
                  padding: 10,
                  fontSize: '18px',
                }}
                style={{ backgroundColor: '#93babb' }}
                toolbarClassName="hide-print"
                wrapperClassName="essay-wrapper"
                editorClassName="essay-editor"
                readOnly={true}
                toolbarHidden
              />
            </div>
          </div>
        </Modal>
        <Modal
          title={'Guide'}
          style={{ top: 20, height: '80%' }}
          visible={showPopup}
          width="70%"
          bodyStyle={{ padding: 0 }}
          closable={false}
          footer={
            <div>
              <Button onClick={() => setShowPopup(false)} type="secondary">
                Close
              </Button>

              <Button onClick={handleGuideCloseClick} type="primary">
                Don't show today{' '}
              </Button>
            </div>
          }
        >
          <div
            className="guide-wrap"
            style={{
              display: 'flex',
            }}
          >
            <CaretLeftOutlined onClick={() => carouselRef.current && carouselRef.current.prev()} style={{ fontSize: '30px' }} />
            <div
              style={{
                width: 'calc(100% - 60px)',
              }}
            >
              <Carousel ref={carouselRef} infinite={false}>
                <div>
                  <img src="/images/LevelUp/recording/1.jpg" style={{ margin: 'auto', width: '100%' }} alt="1" />
                </div>
                <div>
                  <img src="/images/LevelUp/recording/2.jpg" style={{ margin: 'auto', width: '100%' }} alt="2" />
                </div>
                <div>
                  <img src="/images/LevelUp/recording/3.jpg" style={{ margin: 'auto', width: '100%' }} alt="3" />
                </div>
                <div>
                  <img src="/images/LevelUp/recording/4.jpg" style={{ margin: 'auto', width: '100%' }} alt="4" />
                </div>
              </Carousel>
            </div>
            <CaretRightOutlined onClick={() => carouselRef.current && carouselRef.current.next()} style={{ fontSize: '30px' }} />
          </div>
        </Modal>
        <div className="external-content-wrap fluency-con">
          <div className="lesson1-con fluency-bg">
            <div className="lesson1_wrap fluency-wrap">
              <h1
                style={{
                  padding: '10px',
                  paddingLeft: '50px',
                  width: '100%',
                  color: '#676767',
                  fontSize: '24px',
                  marginBottom: height <= 0.85 && 0,
                }}
              >
                Speed Reading
              </h1>
            </div>
            <div className="lesson1_wrap fluency-wrap">
              <div className="fluency-left">
                <div className="sentence-wrap" style={{ background: '#fff', overflowY: 'scroll', overflowX: 'auto' }}>
                  <p
                    style={{
                      lineHeight: '30px',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: dataNew.length > 0 ? dataNew[currentPage]['text'].replace(/\n/g, '<br/>') : '',
                    }}
                  ></p>
                </div>
                <div className="fluency-wrap control-box" style={{ marginTop: `${height < 0.8 ? 0 : (height + width) * 14}px` }}>
                  <img
                    src="/images/external/left-icon.png"
                    alt="prev Btn"
                    className={`pagination-left ${isRecording ? 'disabled' : ''}`}
                    onClick={() => !isRecording && pageMove(currentPage ? currentPage - 1 : 0)}
                    style={{ transform: `scale(${(height + width) / 2.5})`, transformOrigin: 'center' }}
                  />
                  <div className="pager" style={{ margin: '0 15px' }}>
                    <span>
                      {currentPage + 1}/{dataNew.length}
                    </span>
                  </div>
                  <img
                    src="/images/external/right-icon.png"
                    alt="next Btn"
                    className={`pagination-right ${isRecording ? 'disabled' : ''}`}
                    onClick={() => !isRecording && pageMove(currentPage < totalPage - 1 ? currentPage + 1 : currentPage)}
                    style={{ transform: `scale(${(height + width) / 2.5})`, transformOrigin: 'center' }}
                  />
                </div>
              </div>
              <div className="fluency-right">
                <div className="right-con right">
                  <div className="top-header">
                    <h2 style={{ padding: `${24 * height}px ${72 * width}px` }}>Content Description</h2>
                  </div>
                  <div className="btm-con">
                    <div className="count-con">
                      <div>
                        <h3 style={{ fontWeight: '700' }}>Word Count</h3>
                        <h3 className="count-num">{word_count}</h3>
                      </div>

                      <div>
                        <h3 style={{ fontWeight: '700' }}>WPM Goal</h3>
                        <h3 className="goal-num">
                          <span>{WPM_GOAL[1]}</span>
                        </h3>
                      </div>

                      {currentDoneValue && (
                        <>
                          <div>
                            <h3 style={{ fontWeight: '700' }}>Duration Time</h3>
                            <h3 className="goal-num">
                              <span>{`${parseInt(currentDoneValue.duration / 1000 / 60)}:${
                                parseInt(currentDoneValue.duration / 1000) % 60
                              }`}</span>
                            </h3>
                          </div>
                          <div>
                            <h3 style={{ fontWeight: '700' }}>My WPM</h3>
                            <h3 className={`goal-num ${currentDoneValue.wpm > WPM_GOAL[1] ? 'green-number' : 'red-number'}`}>
                              <span>{parseInt(currentDoneValue.wpm)}</span>
                            </h3>
                          </div>
                          <div>
                            <h3 style={{ fontWeight: '700' }}>Accuracy</h3>
                            <h3 className={`goal-num ${currentDoneValue.accuracy > 80 ? 'green-number' : 'red-number'}`}>
                              <span>{currentDoneValue.accuracy > 80 ? 'Pass' : 'Fail'}</span>
                            </h3>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="result-con" style={{ background: '#fff', flexDirection: 'column' }}>
                      <div className="count-bar">
                        <input type="range" className="soundSlider" min={0} max={100} step={1} value={currentProgressSlider} />
                      </div>

                      <div className="btn-wrap">
                        <img
                          className={`${isRecording ? 'blink_dark' : ''}`}
                          src={`${isRecording ? '/images/external/stop-icon-levelup.png' : '/images/external/stop-icon.png'}`}
                          onClick={() => {
                            if (isRecording) {
                              const activeRecorder = recordAudio.current?.[currentPage] || recordAudio.current?.[lastPage];
                              message.info(activeRecorder ? '녹음을 처리하고 있습니다.' : '녹음 시작이 취소되었습니다. 다시 시도해주세요.');
                            }
                            setIsRecording((recording) => !recording);
                          }}
                          alt="start Btn"
                        />
                        <img
                          src={playing ? '/images/external/stop-play.png' : '/images/external/play-icon.png'}
                          onClick={() => {
                            if (lastBlob && !isRecording) {
                              setPlaying((prev) => !prev);
                            }
                          }}
                          alt="play Btn"
                          style={{ filter: `grayscale(${isRecording ? '100%' : '0%'})`, cursor: `${isRecording ? 'default' : 'pointer'}` }}
                        />
                        <img
                          src="/images/external/upload-icon.png"
                          style={{ filter: `grayscale(${isRecording ? '100%' : '0%'})`, cursor: `${isRecording ? 'default' : 'pointer'}` }}
                          onClick={!isRecording && handleUploadClick}
                          alt="share Btn"
                        />
                      </div>

                      <div className="right-con result-time-wrap">
                        <h3 onClick={() => !processCallbackLoading[currentPage] && openModel()}>Result</h3>
                        {processCallbackLoading[currentPage] ? (
                          <Spin size="large" indicator={antIcon} style={{ position: 'absolute', maxWidth: '100px' }} />
                        ) : null}
                        <h3>
                          After <span>{parseInt((word_count * 3) / 10)}</span> seconds
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {playing ? (
          <ReactPlayer
            controls
            width={0}
            height={0}
            url={lastBlob}
            loop={false}
            playing={playing}
            onEnded={() => setPlaying(false)}
            onError={() => setPlaying(false)}
            onProgress={(progress) => {
              console.log((progress.playedSeconds / progress.loadedSeconds) * 100);

              setCurrentProgressSlider((progress.playedSeconds / progress.loadedSeconds) * 100);
            }}
          />
        ) : null}
      </Wrapper>
    </>
  );
};

export default LevelupRecording;
